import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, Button, Collapse, createFilterOptions, Grid, TextField } from '@mui/material';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import CargoGroupModel from './models/CargoGroupModel';
import CargoTypeModel from './models/CargoTypeModel';
import { cargoTypeSelectorSelector, setCargoGroups, setCargoTypes } from './reducers/CargoTypeSelectorReducer';
import './CargoTypeSelector.scss';
import CargoTypeSelectorApi from './api/CargoTypeSelectorApi';

interface CargoSelectorProp {
    cargoTypeValue?: CargoTypeModel | null,
    isGroupDisabled: boolean,
    className?: string,
    onChange?: (cargoType: CargoTypeModel | null) => void
}

const CargoTypeSelector: React.FunctionComponent<CargoSelectorProp> = (props) => {
    const defaultCargoTypeValue: CargoTypeModel | null = props.cargoTypeValue ? props.cargoTypeValue : null;
    const defaultCargoGroupValue: CargoGroupModel | null = props.cargoTypeValue ? {
        cargoGroupName: props.cargoTypeValue.cargoGroupName
    } as CargoGroupModel : null;

    let dispatch = useDispatch();
    let cargoTypeSelectorData = useSelector(cargoTypeSelectorSelector);
    let [cargoTypeValue, setCargoTypeValue] = useState<CargoTypeModel | null>(defaultCargoTypeValue);
    let [cargoGroupValue, setCargoGroupValue] = useState<CargoGroupModel | null>(defaultCargoGroupValue);
    const [open, setOpen] = useState(false);
    const filterLimit = 10;

    useEffect(() => {
        let portValue = props.cargoTypeValue ? props.cargoTypeValue : null;
        let areaValue = props.cargoTypeValue ? {
            cargoGroupName: props.cargoTypeValue.cargoGroupName
        } as CargoGroupModel : null;

        setCargoTypeValue(portValue);
        setCargoGroupValue(areaValue);
    }, [props.cargoTypeValue])

    useEffect(() => {
        if (cargoTypeSelectorData.cargoTypes.length === 0) {
            CargoTypeSelectorApi.GetCargoTypes()
                .then((response: BaseResponse<CargoTypeModel[]>) => {
                    if (response.success) {
                        let cargoGroups: CargoGroupModel[] = [];

                        _.each(response.data, (cargoType) => {
                            if (cargoType.cargoGroupName) {
                                let selectedCargoGroup = _.find(cargoGroups, (cargoGroup: CargoGroupModel) => {
                                    return cargoGroup.cargoGroupName === cargoType.cargoGroupName;
                                });

                                if (!selectedCargoGroup) {
                                    cargoGroups.push({
                                        cargoGroupName: cargoType.cargoGroupName,
                                        positive: true
                                    } as CargoGroupModel);
                                }
                            }

                            cargoType.positive = true;
                        });

                        dispatch(setCargoTypes(response.data));
                        dispatch(setCargoGroups(cargoGroups));
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    Utility.Alert.Error(error);
                });
        }
    }, []);

    return <>
        {
            cargoTypeSelectorData.cargoTypes &&
            <Grid container className={props.className ? props.className : ""}>
                <Grid item xs={6}>
                    <Autocomplete
                        value={cargoTypeValue}
                        options={cargoTypeSelectorData.cargoTypes}
                        renderInput={(params) => <TextField {...params} label="Cargo" />}
                        getOptionLabel={(option: CargoTypeModel) => {
                            return option.name;
                        }}
                        onChange={(event: React.SyntheticEvent<Element, Event>, value: CargoTypeModel | null, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<CargoTypeModel>) => {
                            let cargoTypeValue = value as CargoTypeModel;
                            if (props.onChange) {
                                props.onChange(cargoTypeValue);
                            }

                            if (value) {
                                setCargoTypeValue(cargoTypeValue);

                                let cargoGroupModel = {
                                    cargoGroupName: cargoTypeValue.cargoGroupName,
                                } as CargoGroupModel;
                                setCargoGroupValue(cargoGroupModel);
                            } else {
                                setCargoTypeValue(null);

                                setCargoGroupValue(null);
                            }
                        }}
                        filterOptions={createFilterOptions({
                            limit: filterLimit
                        })}
                    />
                </Grid>
                <Grid item xs={6}>
                    <Autocomplete
                        value={cargoGroupValue}
                        options={cargoTypeSelectorData.cargoGroups}
                        open={open}
                        onOpen={() => !props.isGroupDisabled && setOpen(true)}
                        onClose={() => setOpen(false)}
                        disableClearable={props.isGroupDisabled}
                        disabled={props.isGroupDisabled}
                        getOptionLabel={(option: CargoGroupModel) => {
                            return option.cargoGroupName ? option.cargoGroupName : "";
                        }}
                        renderInput={(params) => <TextField {...params} label="Group" disabled={props.isGroupDisabled} />}
                        onChange={(event: React.SyntheticEvent, value: CargoGroupModel | null, reason: string, details?: AutocompleteChangeDetails<CargoGroupModel> | undefined) => {
                            setCargoGroupValue(value as CargoGroupModel);
                        }}
                        filterOptions={createFilterOptions({
                            limit: filterLimit
                        })}
                    />
                </Grid>
            </Grid>
        }
    </>;
};

export default CargoTypeSelector;